import { render, staticRenderFns } from "./StepInitCountry.vue?vue&type=template&id=0bfb3017&scoped=true&"
import script from "./StepInitCountry.vue?vue&type=script&lang=js&"
export * from "./StepInitCountry.vue?vue&type=script&lang=js&"
import style0 from "./StepInitCountry.vue?vue&type=style&index=0&id=0bfb3017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb3017",
  null
  
)

export default component.exports